import { classNames } from "primereact";
import { observer } from "mobx-react";
import { Card } from "primereact/card";
import { Divider } from "primereact/divider";
import { ProgressBar } from "primereact/progressbar";
import { Toolbar } from "primereact/toolbar";
import React, { useContext, useState } from "react";
import {
  DesktopClient,
  DeviceType,
} from "../../../api/firebase/types/device.types";
import SaveCancelFooter from "../../../components/footer/SaveCancelFooter";
import ToastContext from "../../../components/toast/ToastContext";
import { FormControlProps } from "../../../components/validation/FormControlled";
import { useMediaQuery } from "../../../hooks/responsiveLayout";
import DeviceStore from "../../../store/DeviceStore";
import { DeviceToasts } from "../../../toastMessages/deviceToastMessages";
import DeviceSettingsHeader from "./DeviceSettingsHeader";
import DeviceSettingsForm from "./DeviceSettingsForm";

type DeviceSettingsCardProps = {
  currentDevice: DeviceType | DesktopClient;
  useFormMethods: FormControlProps;
};

const DeviceSettingsCard: React.FC<DeviceSettingsCardProps> = ({
  currentDevice,
}) => {
  const [width] = useMediaQuery();
  const [showLoader, setShowLoader] = useState<boolean>(false);

  const showToast = useContext(ToastContext);

  const onCancelDeviceSettings = () => {
    DeviceStore.resetCurrentDevice();
  };

  const updateCurrentDevice = (updatedDevice: DeviceType | DesktopClient) => {
    setShowLoader(true);
    DeviceStore.updateCurrentDevice(updatedDevice)
      .then(() => {
        showToast(DeviceToasts.deviceSettingsSaved);
      })
      .catch(() => {
        showToast(DeviceToasts.deviceSettingsSaveError);
      })
      .finally(() => setShowLoader(false));
  };

  return (
    <Card
      className={classNames("p-col", {
        "p-m-2": width < 580,
      })}
      footer={() => (
        <SaveCancelFooter
          formId="device-settings"
          cancelAction={onCancelDeviceSettings}
        />
      )}
    >
      {showLoader && <ProgressBar mode="indeterminate" />}
      <Toolbar
        left={() => <h2>{currentDevice.name}</h2>}
        right={() => (
          <DeviceSettingsHeader
            currentDevice={currentDevice}
            setShowLoader={setShowLoader}
          />
        )}
      />
      <Divider />
      <DeviceSettingsForm
        currentDevice={currentDevice}
        onSave={updateCurrentDevice}
      />
    </Card>
  );
};

export default observer(DeviceSettingsCard);
